import MessageContainer from './container';
import Message from './Message';

export { Message };
export default MessageContainer;
